export enum ViewByStatus {
    OBJECT = "Object",
    DATA_FIELD = "Data field",
}
